type Dimensions = { width: number; height: number };
/** HTML dimensions belong to the actual src, not a made-up display box. */
export function carImageAttributes(
  source: string,
  dimensions?: Record<string, Dimensions>,
): { width?: number; height?: number } {
  const value = dimensions?.[source];
  return value && Number.isFinite(value.width) && Number.isFinite(value.height) &&
    value.width > 0 && value.height > 0 ? value : {};
}
export function carImageAspectRatio(dimensions?: Record<string, Dimensions>): string | undefined {
  const value = Object.values(dimensions || {}).find(item => item.width > 0 && item.height > 0);
  return value ? `${value.width} / ${value.height}` : undefined;
}
